import { makeStyles } from "@mui/styles";

export default makeStyles(theme => ({
  quizTopBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    paddingBottom: "10px",
    "& h2": {
      fontSize: "20px",
      fontWeight: "400",
      color: "#1F2329",
      margin: 0
    }
  },
  quizContentWrapper: {
    padding: "10px 0",
    minHeight: "50vh"
  },
  questionTracker: {
    color: "#8B92A5",
    fontSize: "14px",
    fontWeight: "500",
    marginBottom: "10px"
  },
  questionText: {
    fontSize: "22px",
    fontWeight: "400",
    color: "#1F2329",
    lineHeight: "1.5",
    marginBottom: "30px",
    textAlign: "left"
  },
  optionsList: {
    display: "flex",
    flexDirection: "column",
    gap: "15px"
  },
  optionItem: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    padding: "15px 20px",
    border: "1px solid #EBEBEB",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    backgroundColor: "#fff",
    color: "#333",
    "&:hover": {
      borderColor: theme.palette.primary.main
    }
  },
  optionItemActive: {
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    color: "#fff",
    "& $optionLabel": {
      color: "#fff"
    },
    "& $optionText": {
      color: "#fff"
    }
  },
  optionItemCorrect: {
    backgroundColor: "#16B364",
    borderColor: "#16B364",
    color: "#fff",
    "& $optionLabel": {
      color: "#fff"
    },
    "& $optionText": {
      color: "#fff"
    }
  },
  optionItemIncorrect: {
    backgroundColor: "#F04438",
    borderColor: "#F04438",
    color: "#fff",
    "& $optionLabel": {
      color: "#fff"
    },
    "& $optionText": {
      color: "#fff"
    }
  },
  optionLabel: {
    fontWeight: "400",
    fontSize: "16px",
    width: "20px"
  },
  optionText: {
    fontSize: "15px"
  },
  askAiContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    minHeight: "300px",
    "& img": {
      width: "90px",
      height: "auto",
      marginBottom: "10px"
    },
    "& h3": {
      color: theme.palette.primary.main,
      fontSize: "28px",
      fontWeight: "bold",
      margin: 0
    }
  },
  quizPaginationWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "40px",
    paddingTop: "20px",
    gap: "16px"
  },
  quizPageNumbers: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
    justifyContent: "center"
  },
  quizPageBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #D9D9D9",
    borderRadius: "4px",
    backgroundColor: "#fff",
    color: "#8B92A5",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "400",
    transition: "all 0.2s",
    "&:disabled": {
      borderColor: "#EBEBEB",
      color: "#B4B4B4",
      cursor: "not-allowed"
    }
  },
  quizPageBtnText: {
    padding: "8px 16px",
    borderRadius: "6px"
  },
  quizPageBtnNext: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    borderColor: theme.palette.primary.main,
    "&:disabled": {
      backgroundColor: "#EBEBEB",
      color: "#B4B4B4",
      borderColor: "#EBEBEB"
    }
  },
  quizPageBtnNumber: {
    width: "34px",
    height: "34px",
    padding: 0,
    color: "#B4B4B4"
  },
  timercont: {
    padding: "26px",
    border: "1px solid #F0F2F5",
    borderRadius: "8px",
    boxShadow: "0px 0px 3px 0px #00000040",
    marginBottom: "24px",
    "& h5": {
      color: "#6C737F",
      fontSize: "18px",
      fontWeight: "400",
      marginBlock: "0px 14px"
    }
  },
  times: {
    height: "auto",
    maxWidth: "150px",
    margin: "0 auto"
  },
  quizPageNumberCurrent: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main
  },
  quizPageNumberAnswered: {
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    color: "#fff"
  },
  statCard: {
    padding: "20px",
    border: "1px solid #EBEBEB",
    borderRadius: "8px",
    backgroundColor: "#fff"
  },
  statLabel: {
    fontSize: "12px",
    color: "#8B92A5",
    margin: "0 0 10px 0",
    fontWeight: "500"
  },
  statValueBlack: {
    margin: 0,
    fontSize: "24px",
    fontWeight: "600",
    color: "#1F2329"
  },
  statValueGreen: {
    margin: 0,
    fontSize: "24px",
    fontWeight: "600",
    color: "#2EAC34"
  },
  statValueRed: {
    margin: 0,
    fontSize: "24px",
    fontWeight: "600",
    color: "#E93831"
  },
  aiActionBtn: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "12px 16px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "#FFF",
    cursor: "pointer",
    fontSize: "14px",
    color: "#344054",
    textAlign: "left",
    width: "100%",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      background: "#EEF5FF",
      borderColor: "#BACCFF"
    }
  }
}));
